import React from "react";
import { FeedHeaderWithLogoProps } from "web/react/components/feed-header-with-logo/feed-header-with-logo";
import { Heading } from "web/react/emo/heading";
import { Text } from "web/react/emo/text";
import { VStack } from "web/react/emo/v-stack";
import { VerifiedBadge } from "web/react/emo/verified-badge";
import { useDomViewport } from "web/react/hooks/use-dom-viewport/use-dom-viewport";
import * as styles from "./feed-header-title.css";

export function FeedHeaderTitle({
    type,
    title,
    subtitle,
    showVerifiedTick,
}: Pick<FeedHeaderWithLogoProps, "type" | "title" | "subtitle" | "showVerifiedTick">): JSX.Element {
    const { isDesktopViewport } = useDomViewport();

    const subtitleElement = subtitle && (
        <Text as={"span"} textStyle={"caption-1"}>
            {subtitle}
        </Text>
    );

    if (type === "RELATED_PRODUCTS") {
        return (
            <div data-testid="feed-header-title">
                <VStack spacing="xxs">
                    {subtitleElement}
                    <Heading textStyle={{ sm: "title-2", lg: "large-title-2" }} linkReset={false}>
                        {title}
                    </Heading>
                </VStack>
            </div>
        );
    }

    return (
        <VStack spacing="xxs">
            <div data-testid="feed-header-title" className={styles.titleContainer}>
                <Heading
                    textStyle={{
                        sm: "title-2",
                        lg: isDesktopViewport ? "hero" : "large-title-2",
                    }}
                >
                    {title}
                </Heading>
                {showVerifiedTick && <VerifiedBadge className={styles.verifiedIcon} />}
            </div>
            {subtitleElement}
        </VStack>
    );
}
